var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11229 5.66667C1.42587 5.91373 1 6.25797 1 6.63877C1 7.39057 2.65996 8 4.70763 8C6.75531 8 8.41525 7.39057 8.41525 6.63877C8.41525 6.25797 7.98937 5.91373 7.30297 5.66667M4.70763 3.33333H4.71175M7.17938 3.33333C7.17938 4.91366 5.32557 5.66667 4.70763 6.83333C4.08969 5.66667 2.23588 4.91366 2.23588 3.33333C2.23588 2.04467 3.34252 1 4.70763 1C6.07273 1 7.17938 2.04467 7.17938 3.33333ZM5.11959 3.33333C5.11959 3.54811 4.93515 3.72222 4.70763 3.72222C4.4801 3.72222 4.29567 3.54811 4.29567 3.33333C4.29567 3.11856 4.4801 2.94444 4.70763 2.94444C4.93515 2.94444 5.11959 3.11856 5.11959 3.33333Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.64085e339c841fe789449ca76f5bf47b.svg";
export { ForwardRef as ReactComponent };